import { PartConfiguratorTopLevelView } from "src/components/views/erp/configurator/configuratorForm/PartConfiguratorTopLevelView.tsx";
import { ConfigurationCreationApi } from "src/api/generated/erp/configurator/api/configurationCreationApi";
import { UnsavedCustomerOfferLinePartConfiguratorType } from "src/api/generated/erp/configurator/configuratorType/impl/unsavedCustomerOfferLinePartConfiguratorType.ts";
import { FormResult } from "src/components/common/forms/types.ts";
import { DataDirtyStateChangeHandler } from "src/utils/dataDirtyStateChangeHandler.ts";
import { useCustomerOfferLineSubConfigurationImportAction } from "src/components/views/erp/configurator/configuratorForm/impl/useCustomerOfferLineSubConfigurationImportAction.tsx";

export interface CustomerOfferLineBeforeCreateConfiguratorViewProps {
	configuratorType: UnsavedCustomerOfferLinePartConfiguratorType;
	onCompleted: (result: FormResult<number>) => void;
	onDataDirtyStateChanged?: DataDirtyStateChangeHandler;
}

export const CustomerOfferLineBeforeCreateConfiguratorView = ({
	configuratorType,
	onCompleted,
	onDataDirtyStateChanged,
}: CustomerOfferLineBeforeCreateConfiguratorViewProps) => {
	const subConfigurationImportAction = useCustomerOfferLineSubConfigurationImportAction({
		customerOfferId: configuratorType.customerOfferId,
	});

	return (
		<PartConfiguratorTopLevelView
			configuratorType={configuratorType}
			subConfigurationImportAction={subConfigurationImportAction}
			onDataDirtyStateChanged={onDataDirtyStateChanged}
			onCompleted={async (result) => {
				if (result.type === "success") {
					const { propertyValues, propertyInputValues, configurationSessionId } = result.value;
					const partConfigurationId =
						await ConfigurationCreationApi.createPartConfigurationForUnsavedCustomerOfferLine({
							configuratorType: configuratorType,
							propertyValues: propertyValues,
							propertyInputValues: propertyInputValues,
							configurationSessionId: configurationSessionId,
						});
					onCompleted({ type: "success", value: partConfigurationId });
				} else {
					onCompleted(result);
				}
			}}
		/>
	);
};
